import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/membership-groups/:membershipGroupId/members/:membershipGroupMemberId/';

interface DTO {
    parkingId: string;
    membershipGroupId: number;
    membershipGroupMemberId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, membershipGroupId, membershipGroupMemberId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { parkingId, membershipGroupId, membershipGroupMemberId }));
};

interface UseMutationOptions extends MutationConfig<MutationFnType> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as DELETE_MEMBERSHIP_GROUP_MEMBER_RESOURCE, useMutationHook as useDeleteMembershipGroupMember };
export type { DTO as DeleteMembershipGroupMemberDTO };
